import { AbstractControl, ValidatorFn } from "@angular/forms";

export function PhoneValidator(onlyMobileNumbers?: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value) {
            return null;
        }

        let pattern: RegExp;

        if (onlyMobileNumbers) {
            pattern = /^(?=(91|92|93|96))(([0-9])){9}$/;
        } else {
            pattern = /^(?=(2|91|92|93|96))(([0-9])){9}$/;
        }

        const valid: boolean = pattern.test(control.value);

        return valid ? null : { invalidPhoneNumber: true };
    };
}

export function PhoneValidatorES(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value) {
            return null;
        }

        let pattern: RegExp;

        pattern = /^(?=[6-9])(([0-9])){9}$/;

        const valid: boolean = pattern.test(control.value);

        return valid ? null : { invalidPhoneNumber: true };
    };
}
